import { j as e } from '../../../_virtual/jsx-runtime.js';
const s = {
    base: 'w-fit items-center justify-center text-body-strong tablet:text-body-large-strong cursor-pointer',
    focus:
      'focus:ring-3 focus:ring-border-focus-1 active:ring-0 focus:py-0 focus:outline-none focus:border-transparent rounded-radius-200 ',
    visited: 'visited:text-text-link-visited visited:border-text-link-visited',
    iconClass: 'transition-colors',
    text: 'flex flex-inline items-center active:rounded-md border-b active:border-transparent group-focus:border-transparent group-hover:border-transparent px-space-50',
  },
  d = ({ as: o, children: n, leftIcon: t, rightIcon: r, ...i }) => {
    const a = o || 'a';
    return !t && !r
      ? /* @__PURE__ */ e.jsx(a, {
          className: `inline group ${s.base} ${s.visited} ${s.focus}`,
          ...i,
          children: /* @__PURE__ */ e.jsx('span', { className: s.text, children: n }),
        })
      : /* @__PURE__ */ e.jsxs(a, {
          className: `inline-flex group ${s.base} ${s.visited} ${s.focus}`,
          ...i,
          children: [
            t &&
              /* @__PURE__ */ e.jsx('span', {
                className: `mr-space-200 ${s.iconClass}`,
                children: t,
              }),
            /* @__PURE__ */ e.jsx('span', { className: s.text, children: n }),
            r &&
              /* @__PURE__ */ e.jsx('span', {
                className: `ml-space-200 ${s.iconClass}`,
                children: r,
              }),
          ],
        });
  };
export { d as TextLink };
